export const iconFontAwesomeArrowsUpload = (
	<i className="fa-solid fa-upload"></i>
);
